module.exports = __webpack_public_path__ + "img/breathing.2a04537f.jpg";